import styles from './HelpPanel.module.scss';
import { useTranslation } from 'react-i18next';
import HelpCard from './help-card/HelpCard';
import { HELP_CARDS } from './HelpPanel.config';
import { VdsDivider } from '@volt/volt-extended-components-react';
import { Fragment, useMemo } from 'react';
import { DrawerPanel } from '@dmc/ui';
import { userHasPermission } from '@customer/permissions';
import { useAppSelector } from '@customer/store/hooks';
import { DateTime } from 'luxon';

export function HelpPanel() {
  const { t } = useTranslation();
  const userData = useAppSelector(state => state.auth);

  const copyrightYear = useMemo(() => {
    return DateTime.now().toFormat('yyyy');
  }, []);

  return (
    <DrawerPanel
      header={t('Help')}
      footer={
        <div className={styles.footer}>
          {t('DigitalMine')} {userData.appVersion} © {copyrightYear}{' '}
          {t('WabtecCopyrightRightsReserved')}
        </div>
      }
    >
      {HELP_CARDS.filter(link => userHasPermission(userData, link.permission)).map(
        (helpCardProps, i) => {
          return (
            <Fragment key={i}>
              {i > 0 && <VdsDivider padding="spacing-00" />}
              <HelpCard key={helpCardProps.title} {...helpCardProps} />
            </Fragment>
          );
        },
      )}
    </DrawerPanel>
  );
}

export default HelpPanel;
